import { RouteRecordRaw } from "vue-router";
import { LAYOUT } from "../constants";

export default {
  path: "/project",
  redirect: "/project",
  name: "Project",
  component: LAYOUT,
  meta: {
    order: 1,
    title: "项目管理",
  },
  children: [
    {
      path: "",
      name: "ProjectPage",
      component: () => import("../../views/project/ProjectPage.vue"),
      meta: {
        title: "项目管理",
        icon: "project",
      },
    },
    {
      path: "scene",
      name: "ScenePage",
      component: () => import("../../views/scene/ScenePage.vue"),
      meta: {
        title: "模板管理",
        hideMenu: true,
      },
    },
  ],
} as RouteRecordRaw;
